import { Text } from '@/components/commons/typography/Text'
import { skeleton } from '@/components/skeleton/styles/index.css'
import { SocialIconButtonWithWeb } from '@/components/social-networks/SocialIconButtonWithWeb'
import { cssClass } from '@/shared/utils'
import { contentTypeName } from 'containers/highlights/misc/highlightContentType'
import { Highlight } from 'containers/highlights/types/highlights'
import Image from 'next/image'
import { useState } from 'react'

interface HighlightThumbnailProps {
  highlight?: Highlight
  loading?: boolean
  alt?: string
  onClick?: () => void
}

export const HighlightThumbnail = ({
  highlight,
  loading,
  alt,
  onClick,
}: HighlightThumbnailProps) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageError, setImageError] = useState(false)

  const fallbackImage = '/assets/images/fallback-image.jpg' // this does not exist, we need to add a fallback image

  const imageSource = highlight?.image && !imageError ? highlight.image : fallbackImage

  return (
    <div
      className={cssClass([
        'relative full-w',
        imageLoaded && !loading ? 'bg-darkGray2' : skeleton,
        onClick !== undefined ? 'cursor-pointer' : 'no-cursor',
      ])}
      style={{ aspectRatio: '328/335' }}
      onClick={onClick}
    >
      {!loading && highlight && (
        <>
          {imageSource && (
            <Image
              src={imageSource}
              alt={alt ?? highlight.title}
              fill
              style={{ objectFit: 'contain' }}
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageError(true)}
              sizes="(max-width: 600px) 100%, (max-width: 1024px) 33vw, (max-width: 1283px) 340px"
            />
          )}
          {/* TODO: joxxe this code will be commented just in case we want to activate again this field */}
          {/* <div className="absolute top-12 left-12 bg-quaternary  px-8 rounded-6 flex gap-4 items-center">
            <CreatorlandIcon className="text-12 text-info" />
            <Text
              as="span"
              sizeClass="text-12"
              colorClass="cl-white-primary"
              weightClass="font-bold"
            >
              {highlight.type}
            </Text>
          </div> */}
          <div className="absolute top-12 right-12 bg-quaternary  px-8 rounded-6 flex gap-4 items-center">
            <SocialIconButtonWithWeb
              social={highlight?.contentPlatform || 'web'}
              size={13}
              onClick={() => { }}
            />
            <Text
              as="span"
              sizeClass="text-12"
              colorClass="cl-white-primary"
              weightClass="font-bold"
            >
              {contentTypeName(highlight.contentType)}
            </Text>
          </div>
        </>
      )}
    </div>
  )
}
